module.exports = __webpack_public_path__ + "static/img/about1.706628bb.jpg";